import mitt from 'mitt';
/* eslint-disable */
export default {
    install: (app, options) => {
        app.config.globalProperties.$eventBus = mitt();
    }
}